// Register Admin Form (Invite-Only)
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoadingSpinner from "../../components/loader/Loader";
import "./authForm.scss";

import { useRecaptcha, executeRecaptcha } from "../../hooks/useRecaptcha";
import { useRegisterAdminMutation } from "../../features/api/subscriptionApiSlice";

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

const RegisterAdmin = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const inviteToken = params.get("token");

  const [registerAdmin, { isLoading }] = useRegisterAdminMutation();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  useRecaptcha(SITE_KEY, ["/register"]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const isFormValid =
    inviteToken &&
    formData.firstName &&
    formData.lastName &&
    formData.email &&
    formData.password;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const recaptchaToken = await executeRecaptcha(SITE_KEY, "register_admin");

      const res = await registerAdmin({
        token: inviteToken,
        recaptchaToken,
        ...formData,
      }).unwrap();

      toast.success(res.message || "Admin registered!");
      navigate("/login");
    } catch (err) {
      toast.error(err?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="auth-form">
      <div className="main">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <div className="auth-from-container">
            <h2>Admin Registration</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>First Name</label>
                <input
                  name="firstName"
                  onChange={handleChange}
                  value={formData.firstName}
                />
              </div>

              <div className="form-group">
                <label>Last Name</label>
                <input
                  name="lastName"
                  onChange={handleChange}
                  value={formData.lastName}
                />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input
                  name="email"
                  type="email"
                  onChange={handleChange}
                  value={formData.email}
                />
              </div>

              <div className="form-group">
                <label>Password</label>
                <input
                  name="password"
                  type="password"
                  onChange={handleChange}
                  value={formData.password}
                />
              </div>

              <button type="submit" disabled={!isFormValid}>
                Create Admin Account
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default RegisterAdmin;
